var CommunicationProfile = {

    init: function () {
        CommunicationProfile.bindPupilSearch();
    },

    bindPupilSearch: function() {
        $('#communication-profile-pupil-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/communication-profile?pupil=' + $(this).select2('data')[0].id;
        });
    }
}
